import { BoxesIcon } from "assets/icons/BoxesIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { FormikContextType, useFormikContext } from "formik";
import useCurrency from "helpers/useCurrency";
import PercentIcon from "assets/icons/PercentIcon";

function toggleType(data: FormikContextType<MaterialFormulaData>, fieldName: "costType" | "wageType") {
  if (data.values[fieldName] === "price") {
    data.setFieldValue(fieldName, "percent");
  } else {
    data.setFieldValue(fieldName, "price");
  }
}

export default function OtherCosts() {
  const { defCur } = useCurrency();
  const data = useFormikContext<MaterialFormulaData>();
  const v = data.values;
  return (
    <div>
      <div className="flex items-end gap-4 mb-10">
        <BoxesIcon />
        <span className="text-lg">سایر هزینه های تولید</span>
      </div>
      <div className="flex flex-col gap-6">
        <div className="w-[300px]">
          <BasicTextInput
            type="price"
            label="برآورد سربار"
            style={{ padding: "0px 12px 0px 0px" }}
            prefix={
              <div
                className="px-4 border-r cursor-pointer border-slate-300 text-[#1062d0]"
                onClick={() => toggleType(data, "costType")}
              >
                {data.values.costType === "price" ? (
                  <div>{defCur.en_title}</div>
                ) : (
                  <PercentIcon style={{ transform: "scale(0.7)" }} />
                )}
              </div>
            }
            val={v.cost}
            onChange={(val) => data.setFieldValue("cost", val)}
          />
        </div>
        <div className="w-[300px]">
          <BasicTextInput
            type="price"
            label="برآورد دستمزد"
            style={{ padding: "0px 12px 0px 0px" }}
            prefix={
              <div
                className="px-4 border-r cursor-pointer border-slate-300 text-[#1062d0]"
                onClick={() => toggleType(data, "wageType")}
              >
                {data.values.wageType === "price" ? (
                  <div>{defCur.en_title}</div>
                ) : (
                  <PercentIcon style={{ transform: "scale(0.7)" }} />
                )}
              </div>
            }
            val={v.wage}
            onChange={(val) => data.setFieldValue("wage", val)}
          />
        </div>
      </div>
    </div>
  );
}
